module.exports = __webpack_public_path__ + "img/reference-icon-1.44409aca.png";